import { isDefined } from "common/Support";
import type { WireRichTextComponent } from "fluent-components/fluent-components";
import { ErrorBoundary } from "lib/error-boundary";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import * as React from "react";
import type { WireRenderer } from "webapp/wire-renderers/wire-renderer";
import { Wrapper } from "./wire-rich-text-style";

const MarkdownView = lazilyLoadedComponent("markdown-view", () => import("../markdown/markdown-view"));

export const WireRichText: WireRenderer<WireRichTextComponent> = React.memo(p => {
    const { text } = p;
    if (!isDefined(text)) return null;
    return (
        <ErrorBoundary>
            <React.Suspense fallback={<div />}>
                <Wrapper>
                    <MarkdownView disableStyleInjection={true} markdown={text} />
                </Wrapper>
            </React.Suspense>
        </ErrorBoundary>
    );
});
